const phoneDarkSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="110.147px" height="110.156px" viewBox="0 0 110.147 110.156" enable-background="new 0 0 110.147 110.156"
 xml:space="preserve">
<g id="Layer_1">
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
<g>
<path d="M110.069,90.66c-0.35-2.646-1.872-4.934-4.181-6.266L78.711,68.752c-3.326-1.916-7.545-1.352-10.268,1.361l-5.351,5.352
c-1.426,1.42-3.684,1.545-5.247,0.291c-4.217-3.396-8.376-7.133-12.346-11.109c-3.975-3.969-7.705-8.125-11.106-12.348
c-1.258-1.563-1.134-3.813,0.294-5.232l5.345-5.363c2.726-2.711,3.28-6.934,1.363-10.262L25.753,4.27
c-1.334-2.316-3.62-3.842-6.265-4.193c-2.648-0.352-5.244,0.525-7.132,2.414l-8.065,8.063c-5.635,5.635-5.72,15.928-0.253,29.004
c5.255,12.561,15.063,26.402,27.609,38.941c12.552,12.561,26.384,22.359,38.949,27.623c6.436,2.684,12.194,4.035,17.062,4.035
c5.018,0,9.075-1.439,11.935-4.299l8.064-8.066C109.546,95.902,110.426,93.307,110.069,90.66L110.069,90.66z M76.925,71.846
l27.181,15.643c1.344,0.779,2.227,2.102,2.434,3.639c0.166,1.283-0.167,2.561-0.925,3.578L69.5,74.104l1.468-1.471
C72.537,71.059,75,70.727,76.925,71.846L76.925,71.846z M19.021,3.607c1.539,0.205,2.865,1.09,3.639,2.443l15.643,27.172
c1.117,1.936,0.793,4.389-0.788,5.963l-1.343,1.344L15.444,4.533c0.848-0.625,1.864-0.965,2.915-0.965
C18.583,3.568,18.803,3.58,19.021,3.607L19.021,3.607z M97.069,103.338c-4.471,4.477-13.621,4.279-25.097-0.518
c-12.149-5.078-25.577-14.613-37.804-26.84C21.94,63.75,12.406,50.326,7.327,38.176C2.53,26.705,2.339,17.551,6.81,13.086
l5.993-5.996l20.751,36.055l-1.389,1.391c-2.714,2.715-2.957,7.018-0.557,10.004c3.485,4.316,7.308,8.568,11.369,12.635
c4.063,4.057,8.313,7.885,12.631,11.363c2.989,2.404,7.289,2.16,10-0.545l1.272-1.275l36.167,20.637L97.069,103.338
L97.069,103.338z"/>
</g>
</g>
</svg>

`;

export default phoneDarkSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/phoneDarkSVG.js